import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import { formatDateTime } from '~/common';

const Component = (props) => {
    // noinspection JSValidateTypes,JSUnresolvedVariable
    return (
        <TableBody>
            {props.items.map((lead_status) => (
                <TableRow key={lead_status.id}>
                    <TableCell className="adv_sub">
                        {(lead_status.lead_url)
                            ? <Link to={lead_status.lead_url}>{lead_status.adv_sub}</Link>
                            : <>{lead_status.adv_sub}</>
                        }
                    </TableCell>
                    <TableCell className="offer">
                        {(lead_status.offer)
                            ? <Typography noWrap={true}>
                                <Link to={`/offers/${lead_status.offer.offer_name}/`}>
                                    {lead_status.offer.offer_name}
                                </Link>
                        </Typography>
                            : null
                        }
                    </TableCell>
                    <TableCell className="datetime_lead">
                        {(lead_status.datetime_lead)
                            ? formatDateTime(new Date(lead_status.datetime_lead))
                            : null
                        }
                    </TableCell>
                    <TableCell className="vacancy">{lead_status.vacancy}</TableCell>
                    {(lead_status.city_code !== null)
                        ? <Tooltip title={lead_status.city_code} placement="left" arrow={true}>
                            <TableCell className="city">
                                <Typography noWrap={true}>{lead_status.city}</Typography>
                            </TableCell>
                        </Tooltip>
                        : <TableCell className="city">
                            <Typography noWrap={true}>{lead_status.city}</Typography>
                        </TableCell>
                    }
                    <TableCell className="status1">
                        <Typography noWrap={true}>{lead_status.status1}</Typography>
                    </TableCell>
                    {(lead_status.status2)
                        ? <Tooltip title={lead_status.status2} placement="bottom" arrow={true}>
                            <TableCell className="status2">
                                <Typography noWrap={true}>{lead_status.status2}</Typography>
                            </TableCell>
                        </Tooltip>
                        : <TableCell>{lead_status.status2}</TableCell>
                    }
                    <TableCell className="status3">{lead_status.status3}</TableCell>
                    <TableCell className="datetime">
                        {formatDateTime(new Date(lead_status.datetime))}
                    </TableCell>
                </TableRow>
            ))}
        </TableBody>
    );
};

Component.propTypes = {
    items: PropTypes.array,
};

let MemoizedComponent = React.memo(Component, (prevProps, nextProps) => {
    // noinspection JSUnresolvedVariable
    const prevSelectedLead = prevProps.selectedLead;
    // noinspection JSUnresolvedVariable
    const nextSelectedLead = nextProps.selectedLead;

    // noinspection RedundantIfStatementJS
    if (prevSelectedLead !== nextSelectedLead) {
        return false;
    }

    return true;
});

export default MemoizedComponent;
